import request from '@/utils/request'

export function comment(data) {
  return request({
    url: '/index/comment/comment',
    method: 'post',
    data
  })
}

export function getComments(data) {
  return request({
    url: '/index/comment/getComments',
    method: 'post',
    data
  })
}

